var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-attachmenttype"},[_c('v-chip',{attrs:{"x-small":"","color":"info"}},[_vm._v(_vm._s(_vm.typeLong))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }